/**
 * @fileoverview How a Custom Mosaics design leaves the tool: the design
 * consultation link, and the specs PDF rendered by pdf.fireclaytile.com from
 * the island's print sheet (components/SpecSheet.vue).
 *
 * @module handOff
 */

/** Free design consultation booking page. */
export const CONSULTATION_URL = 'https://www.fireclaytile.com/pages/free-design-consultation';

/** Query param that renders the spec sheet instead of the tool. */
export const PRINT_PARAM = 'print';

/** Renders a public page to PDF in headless Chrome with print media. */
const PDF_SERVICE_URL = 'https://pdf.fireclaytile.com/';

/**
 * Whether the current page should render the spec sheet.
 * @param {string} search - `window.location.search`
 * @returns {boolean}
 */
export function isPrintMode(search) {
    return new URLSearchParams(search).get(PRINT_PARAM) === '1';
}

/**
 * The specs PDF for a design: the PDF service rendering the design's share
 * link with `print=1`, so the PDF is exactly the design on screen.
 * @param {string} shareUrl - The design's full share link
 * @param {string} patternId - Used to name the file
 * @returns {string}
 */
export function specsPdfUrl(shareUrl, patternId) {
    const sheet = new URL(shareUrl);
    sheet.searchParams.set(PRINT_PARAM, '1');
    const url = new URL(PDF_SERVICE_URL);
    url.searchParams.set('url', sheet.href);
    url.searchParams.set('filename', `custom_mosaic_${patternId}`);
    return url.href;
}
